// Pass the element obj, start = min val, end = max value, duration = speed, 
function startCounter(element, start, end, duration) {
    // Set current position.
    let current = parseInt(start); 
    // Make sure the end value is an int.
    end = parseInt(end);
    // Used to define the interval's step.
    let range = end - start; 
    // Set the interval step.
    let step = Math.abs(Math.floor(duration / range));
    let content = element.find('span');
    // If cannot find span find numberic value.
    if (content.length == 0) {
        content = element.text();
        var rxp = new RegExp("\\d+", "g");
        // Get the number of items.
        let value = content.match(rxp);
        // Set end value to stop counter.
        end = value;
        element.html(content.replace(rxp, "<span>" + value +"</span>"));
    }

    // Set the interval.
    let timer = setInterval(() => {
        // increment current value.
        current ++;
        // Output current value.
        element.find('span').html(current);
        // If the current value = max value then end interval.
        if (current == end) {
            clearInterval(timer);
            return current;
        }
    }, step);
}

var AXISCounter = $.AXISCounter = {
    start: (element, start, end, duration) => {
       startCounter(element, start, end, duration);
    }
}

export { AXISCounter }